/** ALL GLOBAL STYLESHEETS **/
import './styles/imports.scss';
import HomePage from './pages/home';
import { Component, Suspense } from 'react';
import Log from './utilities/files/log';
import AppRoutes from './routes';
import Loading from './components/loading/Loading';
import { MethodsContext, MethodsModel, StateContext, StateModel } from './context';
import { AuthProvider } from './context/AuthContext';
import Page from './layout';

const componentId = 'app';

class App extends Component<MethodsModel, StateModel> {
  private readonly methods = {} as MethodsModel;
  private readonly setStateAsync: (state: any) => Promise<unknown>;

  constructor(props: any) {
    super(props);

    this.state = {
      page: [],
      loading: false,
    };

    this.methods = {
      setStateAsync: async (state) => {
        return new Promise((resolve) => {
          this.setState(state, () => {
            resolve(null);
          });
        });
      },
      setPage: this.setPage,
      setLoader: this.setLoader,
      setMenuCollapsed: this.setMenuCollapsed,
    };

    // Convenience function to setState as a promise
    this.setStateAsync = (state) =>
      new Promise((resolve) => {
        this.setState(state, () => {
          resolve(null);
        });
      });
  }

  setPage = async (page: string[]) => {
    await this.setStateAsync({ page });
  };

  setLoader = async (loading: boolean) => {
    this.setState({ loading });
    await this.setStateAsync({ loading });
  };

  setMenuCollapsed = async (menuCollapsed: boolean) => {
    console.log('menuCollapsed', menuCollapsed);
    this.setState({ menuCollapsed });
    await this.setStateAsync({ menuCollapsed });
  };

  componentDidMount() {
    Log({ componentId, action: 'App', data: 'App' });
  }

  render() {
    return (
      <AuthProvider>
        <MethodsContext.Provider value={this.methods}>
          <StateContext.Provider value={this.state}>
            <Suspense fallback={<Loading tip="Banner App is Loading..." />}>
              <Page loading={this.state.loading} menuCollapsed={this.state.menuCollapsed}>
                <AppRoutes />
              </Page>
            </Suspense>
          </StateContext.Provider>
        </MethodsContext.Provider>
      </AuthProvider>
    );
  }
}

export default App;
